// https://docs.google.com/spreadsheets/d/1-ksKM-hIaUfxkSEBJIY78HrQ_zg9RZFc0GwUdWg_2Gg/edit?gid=0#gid=0
export const currencyValuesFixed: string[] = [
"Ulaman's Gaze|10",
"Kurgal's Gaze|100",
"Amanamu's Gaze|200",
"Tecrod's Gaze|2000",

"Preserved Rib|5",
"Gnawed Rib|1",
"Preserved Jawbone|2",
"Gnawed Collarbone|2",
"Gnawed Jawbone|2",
"Preserved Collarbone|25",
"Preserved Cranium|25",
"Ancient Rib|500",
"Ancient Jawbone|1500",
"Ancient Collarbone|1500",

"Uul-Netol's Catalyst|1",
"Adaptive Catalyst|1",
"Chayula's Catalyst|1",
"Carapace Catalyst|1",
"Flesh Catalyst|1",
"Xoph's Catalyst|5",
"Tul's Catalyst|5",
"Esh's Catalyst|5",
"Reaver Catalyst|10",
"Skittering Catalyst|15",
"Neural Catalyst|20",
"Sibilant Catalyst|20",

"Scroll of Wisdom|0.001",
"Orb of Augmentation|0.1",
"Greater Orb of Augmentation|1",
"Perfect Orb of Augmentation|10",
"Transmutation Shard|0.02",
"Orb of Transmutation|0.2",
"Greater Orb of Transmutation|1",
"Perfect Orb of Transmutation|10",
"Regal Shard|0.05",
"Regal Orb|0.5",
"Greater Regal Orb|2",
"Perfect Regal Orb|10",
"Exalted Orb|1",
"Greater Exalted Orb|10",
"Perfect Exalted Orb|100",
"Chaos Orb|10",
"Greater Chaos Orb|20",
"Perfect Chaos Orb|200",

"Chance Shard|0.5",
"Orb of Chance|5",
"Orb of Alchemy|1",
"Vaal Orb|1",
"Orb of Annulment|25",
"Divine Orb|100",
"Fracturing Orb|1000",
"Hinekora's Lock|50000",
"Mirror of Kalandra|1000000",
"Albino Rhoa Feather|1000",

"Artificer's Shard|0.15",
"Artificer's Orb|1.5",
"Blacksmith's Whetstone|0.2",
"Glassblower's Bauble|1",
"Armourer's Scrap|1",
"Gemcutter's Prism|2",
"Arcanist's Etcher|1",

"Lesser Jeweller's Orb|1",
"Greater Jeweller's Orb|5",
"Perfect Jeweller's Orb|100",

"Core Destabiliser|20",
"Orb of Extraction|20",
"Crystallised Corruption|50",
"Ancient Infuser|50",
"Architect's Orb|50",
"Vaal Cultivation Orb|1000",

"Lesser Essence of Abrasion|1",
"Lesser Essence of Alacrity|1",
"Lesser Essence of Battle|1",
"Lesser Essence of Command|1",
"Lesser Essence of Electricity|1",
"Lesser Essence of Enhancement|1",
"Lesser Essence of Flames|1",
"Lesser Essence of Grounding|1",
"Lesser Essence of Haste|1",
"Lesser Essence of Ice|1",
"Lesser Essence of Insulation|1",
"Lesser Essence of Opulence|1",
"Lesser Essence of Ruin|1",
"Lesser Essence of Seeking|1",
"Lesser Essence of Sorcery|1",
"Lesser Essence of Thawing|1",
"Lesser Essence of the Body|1",
"Lesser Essence of the Infinite|1",
"Lesser Essence of the Mind|1",

"Essence of Abrasion|1",
"Essence of Alacrity|1",
"Essence of Battle|1",
"Essence of Command|5",
"Essence of Electricity|1",
"Essence of Enhancement|1",
"Essence of Flames|1",
"Essence of Grounding|1",
"Essence of Haste|1",
"Essence of Ice|1",
"Essence of Insulation|1",
"Essence of Opulence|5",
"Essence of Ruin|1",
"Essence of Seeking|1",
"Essence of Sorcery|1",
"Essence of Thawing|1",
"Essence of the Body|1",
"Essence of the Infinite|1",
"Essence of the Mind|1",

"Greater Essence of Abrasion|5",
"Greater Essence of Alacrity|1",
"Greater Essence of Battle|5",
"Greater Essence of Command|1",
"Greater Essence of Electricity|5",
"Greater Essence of Enhancement|1",
"Greater Essence of Flames|1",
"Greater Essence of Grounding|1",
"Greater Essence of Haste|5",
"Greater Essence of Ice|1",
"Greater Essence of Insulation|1",
"Greater Essence of Opulence|50",
"Greater Essence of Ruin|5",
"Greater Essence of Seeking|5",
"Greater Essence of Sorcery|1",
"Greater Essence of Thawing|5",
"Greater Essence of the Body|1",
"Greater Essence of the Infinite|1",
"Greater Essence of the Mind|1",

"Perfect Essence of Abrasion|5",
"Perfect Essence of Alacrity|5",
"Perfect Essence of Battle|50",
"Perfect Essence of Command|2",
"Perfect Essence of Electricity|5",
"Perfect Essence of Enhancement|5",
"Perfect Essence of Flames|2",
"Perfect Essence of Grounding|2",
"Perfect Essence of Haste|50",
"Perfect Essence of Ice|2",
"Perfect Essence of Insulation|2",
"Perfect Essence of Opulence|2",
"Perfect Essence of Ruin|2",
"Perfect Essence of Seeking|2",
"Perfect Essence of Sorcery|5",
"Perfect Essence of Thawing|2",
"Perfect Essence of the Body|2",
"Perfect Essence of the Infinite|2",
"Perfect Essence of the Mind|5",

"Essence of Insanity|10",
"Essence of the Abyss|10",
"Essence of Delirium|25",
"Essence of Hysteria|200",
"Essence of Horror|500",

"Ox Idol|2",
"Cat Idol|2",
"Stag Idol|2",
"Snake Idol|2",
"Boar Idol|2",
"Wolf Idol|2",
"Primate Idol|5",
"Idol of Maxarius|5",
"Idol of Grold|5",
"Idol of Ralakesh|25",
"Owl Idol|5",
"Bear Idol|5",
"Idol of Thruldana|10",
"Idol of Egrin|10",
"Rabbit Idol|100",
"Idol of Sirrius|500",
"Fox Idol|100",
"Idol of Eeshta|500",

"Diluted Liquid Guilt|0.5",
"Diluted Liquid Ire|0.5",
"Diluted Liquid Greed|0.5",
"Liquid Paranoia|1",
"Liquid Envy|2",
"Liquid Disgust|5",
"Liquid Despair|10",
"Concentrated Liquid Fear|50",
"Concentrated Liquid Suffering|150",
"Concentrated Liquid Isolation|500",

"Omen of Gambling|0.5",
"Omen of Putrefaction|1",
"Omen of the Liege|0.5",
"Omen of the Ancients|15",
"Omen of Dextral Necromancy|2",
"Omen of Refreshment|2",
"Omen of Resurgence|2",
"Omen of Sinistral Necromancy|2.5",
"Omen of the Sovereign|2",
"Omen of the Blackblooded|2",
"Omen of Bartering|5",
"Omen of Secret Compartments|5",
"Omen of Chaotic Rarity|20",
"Omen of Chaotic Quantity|10",
"Omen of Amelioration|20",
"Omen of Answered Prayers|5",
"Omen of Greater Exaltation|5",
"Omen of Reinforcements|5",
"Omen of Catalysing Exaltation|10",
"Omen of Chaotic Monsters|10",
"Omen of Sinistral Exaltation|10",
"Omen of Dextral Exaltation|10",
"Omen of Abyssal Echoes|100",
"Omen of the Hunt|10",
"Omen of Sinistral Crystallisation|150",
"Omen of Dextral Crystallisation|150",
"Omen of the Blessed|100",
"Omen of Sanctification|500",
"Omen of Chance|2000",
"Omen of Light|2000",
"Omen of Whittling|2000",
"Omen of Dextral Annulment|2000",
"Omen of Dextral Erasure|2000",
"Omen of Sinistral Annulment|2000",
"Omen of Sinistral Erasure|2000",

"Lesser Adept Rune|0.2",
"Lesser Body Rune|0.2",
"Lesser Desert Rune|0.2",
"Lesser Glacial Rune|0.2",
"Lesser Inspiration Rune|0.2",
"Lesser Iron Rune|0.5",
"Lesser Mind Rune|0.2",
"Lesser Rebirth Rune|0.2",
"Lesser Resolve Rune|0.2",
"Lesser Robust Rune|0.2",
"Lesser Stone Rune|0.2",
"Lesser Storm Rune|0.2",
"Lesser Vision Rune|0.2",

"Adept Rune|0.5",
"Body Rune|0.5",
"Desert Rune|0.5",
"Glacial Rune|0.5",
"Inspiration Rune|0.5",
"Iron Rune|2",
"Mind Rune|0.5",
"Rebirth Rune|0.5",
"Resolve Rune|0.5",
"Robust Rune|0.5",
"Stone Rune|0.5",
"Storm Rune|0.5",
"Vision Rune|0.5",

"Greater Adept Rune|1",
"Greater Body Rune|1",
"Greater Desert Rune|1",
"Greater Glacial Rune|1",
"Greater Inspiration Rune|1",
"Greater Iron Rune|2",
"Greater Mind Rune|1",
"Greater Rebirth Rune|1",
"Greater Resolve Rune|1",
"Greater Robust Rune|1",
"Greater Stone Rune|1",
"Greater Storm Rune|1",
"Greater Vision Rune|1",

"Greater Rune of Nobility|2",
"Greater Rune of Leadership|5",
"Greater Rune of Tithing|10",
"Greater Rune of Alacrity|20",

"Farrul's Rune of Grace|1",
"Saqawal's Rune of Erosion|2",
"Fenumus' Rune of Draining|2",
"Thane Leld's Rune of Spring|5",
"Farrul's Rune of the Hunt|5",
"Fenumus' Rune of Agony|10",
"Fenumus' Rune of Spinning|5",
"The Greatwolf's Rune of Claws|5",
"Craiceann's Rune of Recovery|2",
"Craiceann's Rune of Warding|2",
"Lady Hestra's Rune of Winter|2",
"Thane Girt's Rune of Wildness|5",
"Thane Grannell's Rune of Mastery|5",
"Thane Myrk's Rune of Summer|5",
"The Greatwolf's Rune of Willpower|5",
"Courtesan Mannan's Rune of Cruelty|100",
"Saqawal's Rune of Memory|25",
"Farrul's Rune of the Chase|100",
"Saqawal's Rune of the Sky|50",
"Countess Seske's Rune of Archery|500",
"Hedgewitch Assandra's Rune of Wisdom|500",

"Cholotl's Soul Core of War|5",
"Tacati's Soul Core of Affliction|5",
"Citaqualotl's Soul Core of Foulness|5",
"Soul Core of Puhuarte|5",
"Hayoxi's Soul Core of Heatproofing|5",
"Zalatl's Soul Core of Insulation|5",
"Soul Core of Atmohua|5",
"Soul Core of Tzamoto|5",
"Soul Core of Opiloti|5",
"Soul Core of Xopec|5",
"Soul Core of Topotante|5",
"Topotante's Soul Core of Dampening|7.5",
"Soul Core of Cholotl|7.5",
"Xipocado's Soul Core of Dominion|7.5",
"Opiloti's Soul Core of Assault|10",
"Soul Core of Tacati|20",
"Atmohua's Soul Core of Retreat|10",
"Soul Core of Zantipi|7.5",
"Uromoti's Soul Core of Attenuation|7.5",
"Guatelitzi's Soul Core of Endurance|10",
"Estazunti's Soul Core of Convalescence|10",
"Soul Core of Ticaba|50",
"Soul Core of Citaqualotl|10",
"Xopec's Soul Core of Power|25",
"Quipolatl's Soul Core of Flow|25",
"Soul Core of Azcapa|50",
"Soul Core of Quipolatl|25",
"Tzamoto's Soul Core of Ferocity|100",
"Soul Core of Zalatl|25",
"Soul Core of Jiquani|100",

"Citaqualotl's Thesis|50",
"Guatelitzi's Thesis|500",
"Quipolatl's Thesis|500",
"Jiquani's Thesis|1000",

"Djinn Barya|0.25",
"Inscribed Ultimatum|0.25",

"Simulacrum Splinter|2",
"Breach Splinter|0.1",

"Uncut Skill Gem (Level 1)|1",
"Uncut Skill Gem (Level 2)|1",
"Uncut Skill Gem (Level 3)|1",
"Uncut Skill Gem (Level 4)|1",
"Uncut Skill Gem (Level 5)|1",
"Uncut Skill Gem (Level 6)|1",
"Uncut Skill Gem (Level 7)|1",
"Uncut Skill Gem (Level 8)|1",
"Uncut Skill Gem (Level 9)|1",
"Uncut Skill Gem (Level 10)|1",
"Uncut Skill Gem (Level 11)|1",
"Uncut Skill Gem (Level 12)|1",
"Uncut Skill Gem (Level 13)|1",
"Uncut Skill Gem (Level 14)|1",
"Uncut Skill Gem (Level 15)|1",
"Uncut Skill Gem (Level 16)|1",
"Uncut Skill Gem (Level 17)|1",
"Uncut Skill Gem (Level 18)|1",
"Uncut Skill Gem (Level 19)|10",
"Uncut Skill Gem (Level 20)|500",

"Uncut Support Gem (Level 1)|1",
"Uncut Support Gem (Level 2)|1",
"Uncut Support Gem (Level 3)|1",
"Uncut Support Gem (Level 4)|1",
"Uncut Support Gem (Level 5)|1",

"Uncut Spirit Gem (Level 4)|5",
"Uncut Spirit Gem (Level 5)|5",
"Uncut Spirit Gem (Level 6)|5",
"Uncut Spirit Gem (Level 7)|5",
"Uncut Spirit Gem (Level 8)|5",
"Uncut Spirit Gem (Level 9)|5",
"Uncut Spirit Gem (Level 10)|5",
"Uncut Spirit Gem (Level 11)|5",
"Uncut Spirit Gem (Level 12)|5",
"Uncut Spirit Gem (Level 13)|5",
"Uncut Spirit Gem (Level 14)|5",
"Uncut Spirit Gem (Level 15)|5",
"Uncut Spirit Gem (Level 16)|5",
"Uncut Spirit Gem (Level 17)|5",
"Uncut Spirit Gem (Level 18)|10",
"Uncut Spirit Gem (Level 19)|100",
"Uncut Spirit Gem (Level 20)|2000",

"Faded Crisis Fragment|100",
"Weathered Crisis Fragment|100",
"Ancient Crisis Fragment|100",

"Kulemak's Invitation|25",
"Cowardly Fate|100",
"Victorious Fate|100",
"Deadly Fate|100",

"Twilight Reliquary Key|200",
"Zarokh's Reliquary Key: Sandstorm Visage|10000",
"Zarokh's Reliquary Key: Blessed Bonds|10000",
"The Arbiter's Reliquary Key|1000",
"Zarokh's Reliquary Key: Sekhema's Resolve|10000",
"Zarokh's Reliquary Key: Against the Darkness|5000",
"Ritualistic Reliquary Key|200",
"Tangmazu's Reliquary Key|5000",
"Xesht's Reliquary Key|1000",
"The Trialmaster's Reliquary Key|5000",
"Olroth's Reliquary Key|1000",
"Zarokh's Reliquary Key: Temporalis|200000",
"Azmeri Reliquary Key|500000",

"Varashta's Blessing|2",
"Tawhoa's Tending|2",
"Daresso's Passion|2",
"Paquate's Pact|2",
"Tacati's Ire|2",
"Arakaali's Lust|5",
"Ahn's Citadel|20",
"Einhar's Beastrite|5",
"Kalisa's Crescendo|5",
"Vilenta's Propulsion|5",
"Kurgal's Leash|5",
"Brutus' Brain|50",
"Ailith's Chimes|5",
"Uruk's Smelting|5",
"Kulemak's Dominion|20",
"Zarokh's Refrain|5",
"Romira's Requital|5",
"Doedre's Undoing|25",
"Kaom's Madness|10",
"Sione's Temper|25",
"Oisín's Oath|5",
"Dreamer's Knell|50",
"Atziri's Communion|2000",
"Bhatair's Vengeance|10",
"Xibaqua's Rending|5",
"Cirel's Cultivation|5",
"Zerphi's Infamy|50",
"Atziri's Call|50",
"Morgana's Tempest|5",
"Tasalio's Rhythm|5",
"Hayoxi's Fulmination|20",
"Zarokh's Revolt|20",
"Atziri's Impatience|200",
"Guatelitzi's Ablation|5",
"Khatal's Rejuvenation|50",
"Atziri's Allure|20",
"Arjun's Medal|20",
"Amanamu's Tithe|100",
"Tecrod's Revenge|100",
"Ratha's Assault|50",
"Dominus' Grasp|10",
"Dialla's Desire|500",
"Arbiter's Ignition|500",
"Ixchel's Torment|2000",
"Xoph's Pyre|2000",
"Atalui's Bloodletting|1000",
"Uhtred's Exodus|1000",
"Esh's Radiance|2000",
"Rigwald's Ferocity|1000",
"Tul's Stillness|2000",
"Garukhan's Resolve|5000",
"Rakiata's Flow|5000",
"Uul-Netol's Embrace|5000",
"Uhtred's Omen|5000",
"Uhtred's Augury|20000",

"Vaal Siphoner|5",



"Essence of the Breach|5",

"Refined Flesh Catalyst|2.5",
"Refined Neural Catalyst|2.5",
"Refined Carapace Catalyst|10",
"Refined Uul-Netol's Catalyst|2.5",
"Refined Xoph's Catalyst|5",
"Refined Tul's Catalyst|10",
"Refined Esh's Catalyst|5",
"Refined Chayula's Catalyst|5",
"Refined Reaver Catalyst|50",
"Refined Sibilant Catalyst|25",
"Refined Skittering Catalyst|10",
"Refined Adaptive Catalyst|2",
"Necrotic Catalyst|10",
"Refined Necrotic Catalyst|100",

"Ancient Diluted Liquid Ire|2",
"Ancient Diluted Liquid Guilt|2",
"Ancient Diluted Liquid Greed|2",
"Ancient Liquid Paranoia|1",
"Ancient Liquid Envy|1",
"Ancient Liquid Disgust|1",
"Ancient Liquid Despair|2",
"Ancient Concentrated Liquid Fear|10",
"Ancient Concentrated Liquid Suffering|10",
"Ancient Concentrated Liquid Isolation|10",
"Potent Liquid Melancholy|5",
"Potent Liquid Ferocity|250",
"Potent Liquid Contempt|1000",
"Ancient Potent Liquid Melancholy|50",
"Ancient Potent Liquid Ferocity|10",
"Ancient Potent Liquid Contempt|500",

"Altered Collarbone|100",

"Shattered Triskelion|100",
"Exceptional Verisium|2.5",
"Medved's Crest of the Circle|1",
"Vorana's Crest of the Scythe|2",
"Uhtred's Crest of the Chalice|5",
"Olroth's Crest of the Sun|150",
"Vaal Armourer's Infuser|25",
"Vaal Blacksmith's Infuser|50",
"Vaal Arcanist's Infuser|5",
"Vaal Catalysing Infuser|50",
"Cryptic Key|25",

"Runic Alloy|1",
"Adaptive Alloy|2.5",
"Protective Alloy|5",
"Expansive Alloy|1",
"Swift Alloy|100",
"Cyclonic Alloy|2.5",
"Prismatic Alloy|5",
"Mystic Alloy|2.5",
"Sovereign Alloy|15",
"Celestial Alloy|500",
"Transcendent Alloy|100",
"The Runebinder's Alloy|500",
"The Runefather's Alloy|25",

"Venerable Starlit Ore|2.5",
"Revered Starlit Ore|5",
"Veridical Starlit Ore|10",
"Warding Starlit Ore|20",
"Starlit Ore|100",

"Blazing Flux|5",
"Chilling Flux|5",
"Crackling Flux|5",
"Void Flux|15",
"Perfect Flux|2000",
"Thaumaturgic Flux (Level 1)|1",
"Thaumaturgic Flux (Level 2)|1",
"Thaumaturgic Flux (Level 3)|1",
"Thaumaturgic Flux (Level 4)|1",
"Thaumaturgic Flux (Level 5)|1",
"Thaumaturgic Flux (Level 6)|1",
"Thaumaturgic Flux (Level 7)|1",
"Thaumaturgic Flux (Level 8)|1",
"Thaumaturgic Flux (Level 9)|1",
"Thaumaturgic Flux (Level 10)|1",
"Thaumaturgic Flux (Level 11)|1",
"Thaumaturgic Flux (Level 12)|1",
"Thaumaturgic Flux (Level 13)|1",
"Thaumaturgic Flux (Level 14)|1",
"Thaumaturgic Flux (Level 15)|1",
"Thaumaturgic Flux (Level 16)|1",
"Thaumaturgic Flux (Level 17)|1",
"Thaumaturgic Flux (Level 18)|1",
"Thaumaturgic Flux (Level 19)|5",
"Thaumaturgic Flux (Level 20)|50",

"Perfect Desert Rune|50",
"Perfect Glacial Rune|50",
"Perfect Storm Rune|50",
"Perfect Iron Rune|100",
"Perfect Body Rune|50",
"Perfect Mind Rune|50",
"Perfect Rebirth Rune|50",
"Perfect Inspiration Rune|25",
"Perfect Stone Rune|25",
"Perfect Vision Rune|25",
"Perfect Robust Rune|25",
"Perfect Adept Rune|25",
"Perfect Resolve Rune|25",

"Idol of Greust|2.5",
"Idol of Yeena|5",
"Idol of Eramir|5",
"Idol of Oak|5",
"Idol of Alira|5",
"Idol of Kraityn|2.5",
"Idol of Silk|1",
"Idol of the Sycophant|1",
"Idol of the Martyr|1",
"Idol of the Pharisee|2.5",
"Panther Idol|5",
"Hawk Idol|25",
"Stoat Idol|2.5",

"Emergent Vigour|100",
"Emergent Possibility|1000",
"Emergent Protection|20",
"Emergent Instinct|50",
"Carved Cunning|500",
"Carved Majesty|2000",
"Carved Mischief|15",
"Carved Tenacity|75",
"Raven-Touched Shard|50",

"Lesser Ward Rune|1",
"Ward Rune|2",
"Greater Ward Rune|2",
"Perfect Ward Rune|100",
"Lesser Charging Rune|1",
"Charging Rune|2",
"Greater Charging Rune|2",
"Perfect Charging Rune|100",

"Warding Rune of Reinforcement|2",
"Warding Rune of Protection|1",
"Warding Rune of Disintegration|1",
"Warding Rune of Desperation|1",
"Warding Rune of Symbiosis|1",
"Warding Rune of Courage|1",
"Warding Rune of Stability|5",
"Warding Rune of Glancing|5",
"Warding Rune of Heart|5",
"Warding Rune of Nourishment|5",
"Warding Rune of Annihilation|1",
"Warding Rune of Armature|5",
"Warding Rune of Obsession|2",
"Warding Rune of Equinox|5",
"Warding Rune of Salvaging|1",
"Warding Rune of Bodyguards|5",
"Warding Rune of Hollowing|2",

"Passion of Aldur|5",
"Breath of Aldur|15",
"Ire of Aldur|5",
"Betrayal of Aldur|5",
"Serle's Triumph|500",
"Cadigan's Epiphany|1000",
"Astrid's Creativity|2000",
"Uhtred's Sidereus|25",
"Kolr's Hunt|100",
"Vorana's Carnage|10",
"Thrud's Might|20",
"Medved's Tending|25",
"Katla's Gloom|25",
"Aldur's Legacy|10000",
"Masterwork Rune|50",

"Ancient Rune of Splinters|1",
"Ancient Rune of Dueling|5",
"Ancient Rune of the Titan|5",
"Ancient Rune of Shattering|5",
"Ancient Rune of Prowess|1",
"Ancient Rune of Control|1",
"Ancient Rune of Discovery|5",
"Ancient Rune of Decay|5",
"Ancient Rune of Witchcraft|1",
"Ancient Rune of the Horde|2",
"Ancient Rune of Animosity|2",
"Ancient Rune of Detonation|5",
"Ancient Rune of Retaliation|2",

"Rune of Vitality|2.5",
"Rune of the Hunt|2.5",
"Rune of Acrobatics|2.5",
"Rune of Culmination|2.5",
"Rune of Renown|2.5",
"Rune of Accumulation|2.5",
"Rune of Foundations|2.5",
"Rune of the Prism|2.5",
"Rune of the Blossom|2.5",
"Rune of Consistency|2.5",
"Rune of Reach|2.5",
"Rune of Vital Flame|1",
"Rune of Confrontation|1",

"Legacy of Bramblejack|100",
"Legacy of Blackbraid|100",
"Legacy of Edyrns Tusks|100",
"Legacy of Kingsguard|100",
"Legacy of Bristleboar|100",
"Legacy of Foxshade|100",
"Legacy of Ashrend|100",
"Legacy of Briskwrap|100",
"Legacy of The Unleashed|100",
"Legacy of Horns of Bynden|100",
"Legacy of Wings of Caelyn|100",
"Legacy of Ezomyte Peak|100",
"Legacy of Deidbell|100",
"Legacy of Elevore|100",
"Legacy of Starkonja's Head|100",
"Legacy of Crown of Thorns|100",
"Legacy of Greymake|100",
"Legacy of Erian's Cobble|100",
"Legacy of The Smiling Knight|100",
"Legacy of The Vile Knight|100",
"Legacy of Northpaw|100",
"Legacy of Candlemaker|100",
"Legacy of Deathblow|100",
"Legacy of Legionstride|100",
"Legacy of Trampletoe|200",
"Legacy of Briarpatch|100",
"Legacy of Bushwhack|100",
"Legacy of Wanderlust|150",
"Legacy of The Knight-errant|100",
"Legacy of Obern's Bastion|100",
"Legacy of Dionadair|100",
"Legacy of Wulfsbane|100",
"Legacy of Chernobog's Pillar|100",
"Legacy of Alkem Eira|100",
"Legacy of Oaksworn|100",
"Legacy of Dunkelhalt|100",
"Legacy of Rondel de Ezo|100",
"Legacy of Brynhand's Mark|100",
"Legacy of Trenchtimbre|100",
"Legacy of Mjölner|100",
"Legacy of Twisted Empyrean|100",
"Legacy of Hoghunt|100",
"Legacy of Hrimnor's Hymn|100",
"Legacy of Brain Rattler|100",
"Legacy of Lifesprig|100",
"Legacy of Duality|100",
"Legacy of Tyranny's Grip|100",
"Legacy of The Sentry|100",
"Legacy of Adonia's Ego|100",
"Legacy of Cursecarver|100",
"Legacy of Dusk Vigil|100",
"Legacy of The Blood Thorn|100",
"Legacy of Quill Rain|100",
"Legacy of Ironbound|100",
"Legacy of Amor Mandragora|100",
"Legacy of Spiteful Floret|100",
"Legacy of Svalinn|100",
"Legacy of Keeper of the Arc|100",
"Legacy of Olrovasara|100",
"Legacy of A Worthy Foe|100",
"Legacy of Serle's Grit|100",
"Legacy of Runeseeker's Call|100",
"Legacy of Facebreaker|100",
"Legacy of Hysseg's Claw|100",

"The Triskelion Reforged|100",
"Head of the King|200",
"Breachlord Sac|500",
"Raven's Reflection|200",
"Breachstone|50",
"Simulacrum|500",
"An Audience with the King|15",

"Call of the Shadows|15",
"Origin Cradle|300",
"Origin Spark|200",
"Origin Core|500",

"Aldur's Saga|1000",
"Medved's Saga|10",
"Vorana's Saga|20",
"Uhtred's Saga|25",
"Olroth's Saga|25",
"Omen of Chaotic Effectiveness|5",

"Lavish Wombgift|10",
"Ornate Wombgift|5",
"Banded Wombgift|5",
"Signet Wombgift|5",
"Revelatory Wombgift|10",

"Helbrym's Hide|2",
"Eonyr's Thunder|50",
"Tangmazu's Thurible|150",
"Catha's Brilliance|250",
"Mórrigan's Insight|25",
"Arbiter's Reach|10",
"Seraph's Heart|750",
"Trickster's Shard|250",
"Esh's Prowess|25",
"Tul's Avalanche|5",
"Breachlord's Amalgam|2500",
"Vruun's Aftermath|2",
"Vruun's Inevitability|5",
"Uhtred's Rite|10",
"Uhtred's Constellation|75",
"Medved's Felling|10",
"Vorana's Siege|2500",
"Styrn's Mountain|5",
"Styrn's Ferocity|15",
"Olroth's Conviction|3000",
"Olroth's Hubris|10",
"Prototype Seventeen|15",
"Her Declaration|1500",
"Breachlord's Rift|500",

"Animus Exchange|20",
"Animus Splinters|20",
"Bitter Dead|20",
"Conductive Runes|20",
"Detonate Living|20",
"Eternal March|20",
"Explosive Transmutation|20",
"Fragments of the Past|20",
"Frostflame Nova|20",
"Grim Pillars|20",
"Hollow Shell|20",
"Leylines|20",
"Powered by Verisium|20",
"Rain of Blades|20",
"Refutation|20",
"Remnants of Kalguur|20",
"Repulsion|20",
"Runic Reprieve|20",
"Skyfall|20",
"Triskelion Cascade|20",
"Verisium Manifestations|20",
"Voltaic Barrier|20",
"Wardbound Minions|20",

"Concussive Runes|20",
"Fist of Kalguur|20",
"Healing Runes|20",
"Runeforged Blades|20",
"Runic Extraction|20",
"Runic Infusion|20",
"Scouring Flame|20",

"Yaomac's Orb of Sacrifice|500",
"Kopec's Orb of Sacrifice|1000",
"Kamasa's Orb of Sacrifice|500",
"Yugul's Orb of Sacrifice|250",

"Expedition Logbook|20",
];
